import React from 'react';
const WaTabIcon = () => React.createElement("span", { className: "sirius-icon sirius-icon-wa" });
WaTabIcon.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-wa sirius-icon-wa-enhance" });
export default WaTabIcon;
